<template>
    <UnitInfo__sensors_template
        :class="[classForValue, $attrs.class]"
        :unitId="unitId"
        :icon="icon"
        :title="$t('Unit.sensors.Last message')"
        :statusClass="statusClass"
        :statusIcon="statusIcon"
        :value="value"
        :showButton="showButton"
        :buttonIcon="'document'"
        :buttonIconTitle="$t('Unit.History of recent messages')"
        @buttonFn="openLmsgsUnitHistory"
        v-if="_showByValue"
    />
    <!-- restoreUnit_Dialog popup -->
    <custom-modal v-if="modalWindows?.lmsgsUnitHistory" v-bind="modalWindows?.lmsgsUnitHistory?.props">
        <LastNMsgsOfUnitTable :unit-id="modalWindows?.lmsgsUnitHistory?.unitId || 0"/>
    </custom-modal>
</template>

<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
import UnitInfo__sensors_template from "@/components/units/sensors/UnitInfo__sensors_template.vue"
import LastNMsgsOfUnitTable from "@/components/units/tables/LastNMsgsOfUnitTable.vue";
import {formatTimeAgo} from "@/lib/lib";

export default {
    name: "UnitInfo__sensors_last_message",
    inheritAttrs: false,
    extends: UnitInfo__sensors_default,
    props: {
        showButton: {
            type: Boolean,
            default: () => true,
        },
    },
    components:{
        UnitInfo__sensors_template,
        LastNMsgsOfUnitTable,
    },
    data() {
        return {
            modalWindows: {}
        }
    },
    computed:{
        value() {
            let timeAgo = this.unitLmsgTimeAgo
            if (!timeAgo && timeAgo !== 0) {
                return '';
            }
            let sign = ''
            if (timeAgo < 0) {
                sign = '-'
                timeAgo *= -1
            }
            //return timeAgo
            let time = formatTimeAgo(timeAgo)

            return time ? sign + this.$t('{time} ago', {time}) : ''
        },
        icon() {
            return this.showIcon ? 'unit_dashboard__massage' : false
        }
    },
    methods:{
        modalClose() {
            this.modalWindows = {}
        },
        openLmsgsUnitHistory() {
            this.modalWindows = {
                'lmsgsUnitHistory': {
                    unitId: this.unitId,
                    props: {
                        title: this.unit?.name + ' - ' + this.$t('Unit.History of recent messages'),
                        btnOkClass: 'button_theme_neutral',
                        btnCanselClass: 'button_theme_danger',
                        btnOkText: this.$t('buttons.Refresh'),
                        buttons: [
                            {id: 'ok', fn: () => {
                                    this.modalWindows = {};
                                    this.$nextTick().then(() => {
                                        this.openLmsgsUnitHistory()
                                    })

                                }},
                            {id: 'cancel', fn: () => this.modalClose()},
                        ]
                    }
                }
            }
        },
    },
}
</script>

<style scoped>

</style>